module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fgBfk"))).then(() => module.bundle.root('esIbd'));